import axios from "axios";
import { getAnioActual, getFechaInicioAnioMes, getFechaFinAnioMes } from "../utils/DateUtils";
import { responseError } from "./UtilService";
const api_url_resenia = process.env.REACT_APP_API_URL + "/resenia";
const api_url_historial = process.env.REACT_APP_API_URL + "/historial";
const api_url_notas = process.env.REACT_APP_API_URL + "/notas";
const api_url_reseniamarcas = process.env.REACT_APP_API_URL + "/marcas/resenia"

export async function getReseniaCliente(id_cliente) {
    let params = "?cliente_id="+id_cliente/*+"&estado=T"*/;
    try {
        let resp = await axios.get(api_url_resenia+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de reseña desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getReseniaMarca(marca_id) {
    let params = "?marca_id="+marca_id/*+"&estado=T"*/;
    console.log(marca_id)
    try {
        const url = api_url_reseniamarcas+params
        let resp = await axios.get(url);
        console.log(resp)
        return {
            error: false,
            data: resp.data.data
        }
    } catch(err) {
        console.error(err);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de reseña desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getHistorialPorMarca(id_cliente, anio, mes) {
    let params = "?agruparPorMarcas=true&";
    if (id_cliente)
        params += "cliente_id="+id_cliente+"&"/*+"&estado=T"*/;
    params += "fechaDesde="+getFechaInicioAnioMes(anio, mes)+"&fechaHasta="+getFechaFinAnioMes(anio, mes);
    try {
        let resp = await axios.get(api_url_historial+params);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de historial desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getHistorial(id_cliente, anio, horizontal=true) {
    let params = "?";
    if (id_cliente)
        params += "cliente_id="+id_cliente+"&"/*+"&estado=T"*/;
    if (anio) {
        params += `fechaDesde=${anio}-01-01&fechaHasta=${anio}-12-31`;
    } else {
        params += `fechaDesde=${getAnioActual().toString()}-01-01&fechaHasta=${getAnioActual().toString()}-12-31`;
    }
    try {
        let resp = await axios.get(api_url_historial+params);
        const historial = resp.data;
        if (horizontal) {
            let cantPedidos = {
                titulo:"Cant. Pedidos"
            };
            let totales = {
                titulo:"Total $"
            };
            let totales_usd = {
                titulo:"Total U$S"
            };
            for (let i=1;i<=12;i++) {
                let reg = historial.data.find(h => parseInt(h.mes)==i);
                if (reg) {
                    cantPedidos[i] = reg.cantidad;
                    totales[i] = reg.total;
                    totales_usd[i] = reg.total_usd;
                } else {
                    cantPedidos[i] = 0;
                    totales[i] = 0.0;
                    totales_usd[i] = 0.0;
                }
            }
            return {
                error: false,
                data: [cantPedidos,totales,totales_usd]
            };
        } else {
            let newData = [];
            for (let i=1;i<=12;i++) {
                let reg = historial.data.find(h => parseInt(h.mes)==i);
                if (reg) {
                    newData.push({
                        anio:reg.anio,
                        mes:reg.mes,
                        cantidad:reg.cantidad,
                        total:reg.total,
                        total_usd:reg.total_usd
                    })
                } else {
                    newData.push({
                        anio:getAnioActual(),
                        mes:i,
                        cantidad:0,
                        total:0.0,
                        total_usd:0.0
                    })
                }
            }
            historial.data = newData;
            return {
                error: false,
                data: historial.data
            };
        }
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de historial desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getNotas (cliente_id, fechaDesde, estado) {
    try {
        let params = ""
        !estado
            ? params =  `?cliente_id=${cliente_id}&fechaDesde=${fechaDesde}&estado=A` 
            : params = `?cliente_id=${cliente_id}&fechaDesde=${fechaDesde}`
        const url = api_url_notas+params
        let resp = await axios.get(url)
        return {
            error: false,
            data: resp.data
        };
    } catch (error) {
        console.error(error.message);
        let resp = {
            error: true,
            message: ""
        }
        if (error.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al obtener datos de historial desde el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function nuevaNota(data) {
    try {
        let resp = await axios.post(api_url_notas, data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al guardar la nota en el servidor.");
            }
            //develver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //develver error de red
        }
        return resp;
    }
}

export async function editarNota(nota_id, data) {
    try {
        let resp = await axios.put(api_url_notas+`/${nota_id}`, data);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            messages: []
        }
        if (err.response) {
            let status = err.response.status;
            if (status===400) {
                resp.messages = err.response.data.mensajes;
            } else {
                resp.messages.push("Hubo un error al editar la nota en el servidor.");
            }
            //devolver error segun estado
        } else {
            resp.messages.push("Hubo un error al intentar conectar con el servidor.");
            //devolver error de red
        }
        return resp;
    }
}

export async function deleteNota (id) {
    try {
        let resp = await axios.delete(api_url_notas+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        console.error(err.message);
        let resp = {
            error: true,
            message: ""
        }
        if (err.response) {
            //let status = err.response.status;
            resp.message = "Hubo un error al borrar la nota en el servidor.";
            //develver error segun estado
        } else {
            resp.message = "Hubo un error al intentar conectar con el servidor.";
            //develver error de red
        }
        return resp;
    }
}

export async function getNota(id) {
    try {
        let resp = await axios.get(api_url_notas+"/"+id);
        return {
            error: false,
            data: resp.data.data
        };
    } catch(err) {
        return responseError(err, "Hubo un error al obtener la nota en el servidor.");
    }
}